import * as v from "vue";
import { ref as k, onMounted as S, watchEffect as P, cloneVNode as T, h as D, Fragment as H } from "vue";
var w;
let U = Symbol("headlessui.useid"), N = 0;
const W = (w = v.useId) != null ? w : function() {
  return v.inject(U, () => `${++N}`)();
};
function b(e) {
  var t;
  if (e == null || e.value == null) return null;
  let n = (t = e.value.$el) != null ? t : e.value;
  return n instanceof Node ? n : null;
}
function O(e, t, ...n) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...n) : o;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, O), r;
}
function j(e, t) {
  if (e) return e;
  let n = t ?? "button";
  if (typeof n == "string" && n.toLowerCase() === "button") return "button";
}
function F(e, t) {
  let n = k(j(e.value.type, e.value.as));
  return S(() => {
    n.value = j(e.value.type, e.value.as);
  }), P(() => {
    var r;
    n.value || b(t) && b(t) instanceof HTMLButtonElement && !((r = b(t)) != null && r.hasAttribute("type")) && (n.value = "button");
  }), n;
}
var R = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(R || {}), L = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(L || {});
function I({ visible: e = !0, features: t = 0, ourProps: n, theirProps: r, ...o }) {
  var i;
  let u = A(r, n), s = Object.assign(o, { props: u });
  if (e || t & 2 && u.static) return g(s);
  if (t & 1) {
    let p = (i = u.unmount) == null || i ? 0 : 1;
    return O(p, { 0() {
      return null;
    }, 1() {
      return g({ ...o, props: { ...u, hidden: !0, style: { display: "none" } } });
    } });
  }
  return g(s);
}
function g({ props: e, attrs: t, slots: n, slot: r, name: o }) {
  var i, u;
  let { as: s, ...p } = B(e, ["unmount", "static"]), l = (i = n.default) == null ? void 0 : i.call(n, r), m = {};
  if (r) {
    let c = !1, h = [];
    for (let [d, f] of Object.entries(r)) typeof f == "boolean" && (c = !0), f === !0 && h.push(d);
    c && (m["data-headlessui-state"] = h.join(" "));
  }
  if (s === "template") {
    if (l = E(l ?? []), Object.keys(p).length > 0 || Object.keys(t).length > 0) {
      let [c, ...h] = l ?? [];
      if (!M(c) || h.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${o} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(p).concat(Object.keys(t)).map((a) => a.trim()).filter((a, y, $) => $.indexOf(a) === y).sort((a, y) => a.localeCompare(y)).map((a) => `  - ${a}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((a) => `  - ${a}`).join(`
`)].join(`
`));
      let d = A((u = c.props) != null ? u : {}, p, m), f = T(c, d, !0);
      for (let a in d) a.startsWith("on") && (f.props || (f.props = {}), f.props[a] = d[a]);
      return f;
    }
    return Array.isArray(l) && l.length === 1 ? l[0] : l;
  }
  return D(s, Object.assign({}, p, m), { default: () => l });
}
function E(e) {
  return e.flatMap((t) => t.type === H ? E(t.children) : [t]);
}
function A(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let o in r) o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n) Object.assign(t, { [r](o, ...i) {
    let u = n[r];
    for (let s of u) {
      if (o instanceof Event && o.defaultPrevented) return;
      s(o, ...i);
    }
  } });
  return t;
}
function V(e) {
  let t = Object.assign({}, e);
  for (let n in t) t[n] === void 0 && delete t[n];
  return t;
}
function B(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t) r in n && delete n[r];
  return n;
}
function M(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var x = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(x || {});
export {
  I as A,
  V as E,
  R as N,
  B as T,
  x as a,
  W as i,
  b as o,
  F as s,
  O as u
};
//# sourceMappingURL=keyboard-D80SCZJ9.mjs.map
